<ngb-timepicker [ngModel]="innerValue"
                [meridian]="true"
                (ngModelChange)="writeValue($event)"
                [spinners]="false"
                [class.required]="required"
                (blur)="onTouched()"></ngb-timepicker>
